export const ISSUE_VIEW_CONSUMER = 'issue-view';
